<template>
  <!-- modal starts -->
  <div class="study_profile_modal__wrapper">
    <div class="study_profile_modal__container">
      <div class="modal__title d-flex justify-content-between py-2 px-3">
        <h4 class="my-0">{{ $t("navigations.create site") }}</h4>
        <!-- <div class="cursor-pointer" @click.prevent="closeModal">
          <i class="fa fa-times" title="Close"></i>
        </div> -->
        <div
          class="tooltip-wrapper pointer"
          style="float: right; cursor: pointer"
        >
          <i class="fa fa-times" @click.prevent="closeModal"></i>
          <span class="custom-tooltip">{{ $t("navigations.close") }}</span>
        </div>
      </div>
      <div class="ibox-content p-3">
        <div class="form-group row">
          <div class="col-lg-3 mb-1">
            <label class="col-form-label"
              >{{ $t("navigations.site code")
              }}<sup><i class="fa fa-asterisk required"></i></sup>
            </label>
            <input
              type="text"
              class="form-control"
              v-model="value.siteCode"
              maxlength="1000"
            />
            <span class="errormsg animated bounce" v-if="errors[0]">
              {{ $t("navigations.please enter site code") }}
            </span>
          </div>
          <div class="col-lg-3 mb-1">
            <label class="col-form-label"
              >{{ $t("navigations.site name") }}
            </label>
            <input
              type="text"
              maxlength="1000"
              class="form-control"
              v-model="value.siteName"
            />
          </div>
          <div class="col-lg-3 mb-1">
            <label class="col-form-label"
              >{{ $t("navigations.site contact name") }}
            </label>
            <input
              type="text"
              class="form-control"
              v-model="value.siteContactName"
              maxlength="1000"
            />
          </div>

          <div class="col-lg-3 mb-1">
            <label class="col-form-label"
              >{{ $t("navigations.site contact email") }}
            </label>
            <input
              type="email"
              class="form-control"
              v-model="value.siteContactEmail"
              maxlength="1000"
            />
            <span class="errormsg" v-if="errors[1]">{{
              $t("navigations.please enter a valid email")
            }}</span>
          </div>
          <div class="col-lg-3 mb-1">
            <label class="col-form-label"
              >{{ $t("navigations.status") }}
            </label>
            <select
              type="text"
              class="form-control"
              name="account"
              v-model="value.status"
              :disabled="value.status"
            >
              <option value="New">{{ $t("navigations.new") }}</option>
              <option v-if="disableStatus" value="Open">
                {{ $t("navigations.open") }}
              </option>
              <option v-if="disableStatus" value="Visit Completed">
                {{ $t("navigations.visit completed") }}
              </option>
              <option v-if="disableStatus" value="Archived">
                {{ $t("navigations.archived") }}
              </option>
              <option v-if="disableStatus" value="Closed">
                {{ $t("navigations.closed") }}
              </option>
              <option v-if="disableStatus" value="Enrolled">
                {{ $t("navigations.enrolled") }}
              </option>
              <option v-if="disableStatus" value="Terminated">
                {{ $t("navigations.terminated") }}
              </option>
              <option v-if="disableStatus" value="Completed">
                {{ $t("navigations.completed") }}
              </option>
              <option v-if="disableStatus" value="Close">
                {{ $t("navigations.close") }}
              </option>
            </select>
          </div>

          <div class="col-lg-3 mb-1">
            <label class="col-form-label"
              >{{ $t("navigations.number of subjects") }}
            </label>
            <input
              type="text"
              class="form-control"
              maxlength="4"
              v-model="value.numberOfPatient"
              @change.prevent="numberonlyvalidation('numberOfPatient')"
            />

            <span class="errormsg" v-if="errors[4]">{{
              $t("navigations.invalid number")
            }}</span>
          </div>
          <div class="col-lg-3 mb-1">
            <label class="col-form-label">{{
              $t("navigations.language")
            }}</label>
            <select
              class="form-control"
              name="account"
              v-model="value.language"
            >
              <option v-for="language in languages" :key="language.id">
                {{ language.language }}
              </option>
            </select>
          </div>
          <div class="col-lg-3 mb-1">
            <label class="col-form-label">{{
              $t("navigations.country")
            }}</label>
            <select
              class="form-control"
              name="account"
              v-model="value.siteAddress.country"
            >
              <option v-for="country in countries" :key="country.id">
                {{ country.country }}
              </option>
            </select>
          </div>
          <div class="col-lg-12 mb-1">
            <label class="col-form-label"
              >{{ $t("navigations.site notes") }}
            </label>
            <input
              type="text"
              class="form-control"
              v-model="value.siteNotes"
              maxlength="1000"
            />
            <span class="errormsg" v-if="errors[5]">{{
              $t("navigations.invalid site note")
            }}</span>
          </div>
          <div class="col-lg-6 my-3 d-flex">
            <div class="input-group date">
              <div class="i-checks">
                <label class="mr-2">{{ $t("navigations.active") }}</label>
                <input
                  type="checkbox"
                  checked="checked"
                  value=""
                  v-model="value.active"
                />
              </div>
            </div>
          </div>
          <div class="col-lg-6 my-3 d-flex justify-content-lg-end">
            <button
              class="cancel_btn py-1 px-4 mx-3"
              type="submit"
              @click="clear()"
            >
              {{ $t("navigations.clear") }}
            </button>
            <button class="save_btn py-1 px-4" type="submit" @click="save()">
              {{ $t("navigations.save") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- modal ends -->
</template>
<script src="./CreateSitePopUp.js"></script>
<style scoped>
.study_profile_modal__wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  z-index: 3000;
}
.study_profile_modal__container {
  position: fixed;
  width: min(50%, 90%);
  border-radius: 4px;
  background: #fff;
  overflow-x: hidden;
}
.modal__title {
  background-color: var(--pop-up-background);
  color: #fff;
}
.cancel_btn {
  padding: 0.43rem 0.4rem;
  border-radius: 0.25rem;
}
.tooltip-wrapper {
  position: relative;
  display: inline-block;
}

.custom-tooltip {
  visibility: hidden;
  width: 60px;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: -18%; /* Position the tooltip above the icon */
  left: -375%;
  margin-left: -30px; /* Use half of the width to center-align */
  opacity: 0;
  transition: opacity 0.3s;
  font-size: 12px;
}

.tooltip-wrapper:hover .custom-tooltip {
  visibility: visible;
  opacity: 1;
}
</style>